<template lang="pug">
.tracking-tab
  vm-form
    vm-input(:placeholder="$t('purchase_orders.notes')" v-model="form.notes" )
    vm-button(:loading="loading" @click="save" class="saveButton") {{ $t('strings.save') }}
  vm-table(max-height="350px" :data="trackings")
    template(slot="thead")
      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_orders.' + column) }}
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in trackings")
        vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns" width="300px")
          slot {{data[indextr][column] }}

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'TrackingTab',
  data: () => ({
    form: {
      notes: ''
    },
    columns: [
      'notes',
      'created_at',
      'user_display'
    ]
  }),
  computed: {
    ...mapGetters(['trackings'])
  },
  async created () {
    await this.loadTrackings({ id: this.$route.params.id })
  },
  methods: {
    ...mapActions(['loadTrackings', 'addTracking']),
    async save () {
      await this.addTracking({ id: this.$route.params.id, ...this.form })
      this.form.notes = ''
    }
  }
}
</script>

<style lang="scss">
.tracking-tab {
  .saveButton {
    margin: 20px 0;
  }
}
</style>
